/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import OverlayScrollbars from 'overlayscrollbars';

declare global {

  /**
   * Custom `Window` type extensions.
   */
  interface Window {

    /**
     * Register a function found in the
     * [Overlay Scrollbars](https://kingsora.github.io/OverlayScrollbars) library.
     */
    OverlayScrollbars: typeof OverlayScrollbars;

    /**
     * `true` enables attaching overlay scrollbars with the `useOverlayScrollbars()` method.
     */
    lservCustomScrollbars: boolean;

    /**
     * Default application-specific scroller options
     */
    lservCustomScrollbarsOptions: {
      autoHide: string;
    };
  }

  /**
   * Custom `Element` type extensions.
   */
  interface Element {
    /**
     * Set to `true` if the element has been attached overlay scrollbars using
     * the `useOverlayScrollbars()` method.
     */
    lservWithOverlayScrollbars: boolean;
  }
}

/**
 * Attaches application-styled scrollbars to the specified element. This method assumes that
 * the attached `container` element has native scrolling capabilities (which are just replaced with
 * custom scrolling UI by this method).
 *
 * @param container  an element that should be transformed from having native scrollbars to
 *                   the application-styled scrollbars
 */
export function useOverlayScrollbars(container: Element): void {
  if (container.lservWithOverlayScrollbars) {
    return;
  }
  container.lservWithOverlayScrollbars = true;

  if (!window.lservCustomScrollbars) {
    return;
  }

  window.OverlayScrollbars(
      container,
      window.lservCustomScrollbarsOptions as OverlayScrollbars.Options);
}
